import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, getDoc, collection, getDocs, orderBy, query } from 'firebase/firestore';
import { IoArrowBack, IoPeopleOutline, IoStatsChartOutline } from 'react-icons/io5';
import './SeguridadScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';


function ResultadosEncuestasScreen() {
    const { encuestaId } = useParams();
    const navigate = useNavigate();
    const [encuesta, setEncuesta] = useState(null);
    const [votosDetails, setVotosDetails] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [encuestaId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            // 1. Obtener la encuesta principal
            const docRef = doc(db, 'encuestas', encuestaId);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();
                setEncuesta(data);

                // 2. Si no es anónima o si somos admin, obtener el detalle de votos
                const votosRef = collection(db, `encuestas/${encuestaId}/votos`);
                const votosSnap = await getDocs(query(votosRef, orderBy('fecha', 'desc')));
                const votosList = votosSnap.docs.map(d => ({ id: d.id, ...d.data() }));
                setVotosDetails(votosList);
            } else {
                alert("Encuesta no encontrada");
                navigate(-1);
            }
        } catch (error) {
            console.error("Error al cargar resultados", error);
        }
        setLoading(false);
    };

    const getOpcionTexto = (opcionId) => {
        const opt = encuesta?.opciones.find(o => o.id === opcionId);
        return opt ? opt.texto : 'Desconocido/Anónimo';
    };

    const calcularPorcentaje = (votosOpcion) => {
        if (!encuesta?.totalVotos) return 0;
        return Math.round((votosOpcion / encuesta.totalVotos) * 100);
    };

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/admin/encuestas" />
            <main className="ks-main">
                <div className="ks-header-sticky-wrapper">
                    <KondoBrandHeader showBack={false} />
                </div>
                <div className="ks-scroll-area">
                    {loading ? (
                        <div style={{ textAlign: 'center', marginTop: '50px', color: '#6b7280' }}>Cargando resultados...</div>
                    ) : !encuesta ? (
                        <div style={{ textAlign: 'center', marginTop: '50px', color: '#6b7280' }}>Encuesta no encontrada</div>
                    ) : (
                        <div className="seguridad-container" style={{ padding: 0 }}>
                            {/* Sticky Compact Header */}
                            <div className="app-header-sticky" style={{ padding: '15px 15px 0' }}>
                                <div className="kondo-banner-standard" style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', margin: 0 }}>
                                    <div className="banner-standard-content">
                                        <button onClick={() => navigate(-1)} className="banner-back-btn-standard">
                                            <IoArrowBack size={24} />
                                        </button>
                                        <div className="banner-standard-text">
                                            <h2>Resultados</h2>
                                            <p>{encuesta.titulo}</p>
                                        </div>
                                    </div>
                                    <IoStatsChartOutline className="banner-standard-icon-decor" />
                                </div>
                            </div>

                            <div style={{ padding: '20px' }}>
                                {/* RESUMEN GLOBAL */}
                                <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', marginBottom: '20px' }}>
                                    <h3 style={{ margin: '0 0 15px 0', color: '#1f2937' }}>Resumen General</h3>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                        {encuesta.opciones.map(opt => {
                                            const porcentaje = calcularPorcentaje(opt.votos);
                                            return (
                                                <div key={opt.id}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px', fontSize: '0.9rem', fontWeight: 'bold' }}>
                                                        <span>{opt.texto}</span>
                                                        <span>{opt.votos} votos ({porcentaje}%)</span>
                                                    </div>
                                                    <div style={{ width: '100%', height: '10px', backgroundColor: '#f3f4f6', borderRadius: '5px', overflow: 'hidden' }}>
                                                        <div style={{ width: `${porcentaje}%`, height: '100%', backgroundColor: '#8b5cf6' }}></div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>

                                    <div style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #e5e7eb', fontSize: '0.9rem', color: '#6b7280', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Total de votos: <strong>{encuesta.totalVotos || 0}</strong></span>
                                        <span>{encuesta.reglas.esAnonima ? '🔴 Votación Anónima' : '🟢 Votación Pública'}</span>
                                    </div>
                                </div>

                                {/* DETALLE DE VOTOS (SI NO ES ANÓNIMA) */}
                                <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                                    <h3 style={{ margin: '0 0 15px 0', color: '#1f2937', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <IoPeopleOutline /> Detalle de Participación
                                    </h3>

                                    {votosDetails.length === 0 ? (
                                        <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Aún no hay votos registrados.</p>
                                    ) : (
                                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                                            <thead>
                                                <tr style={{ borderBottom: '2px solid #f3f4f6', textAlign: 'left' }}>
                                                    <th style={{ padding: '10px 0', color: '#4b5563' }}>Unidad</th>
                                                    <th style={{ padding: '10px 0', color: '#4b5563' }}>Rol</th>
                                                    <th style={{ padding: '10px 0', color: '#4b5563' }}>Opción Elegida</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {votosDetails.map(voto => (
                                                    <tr key={voto.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                                        <td style={{ padding: '12px 0', fontWeight: 'bold' }}>{voto.numeroCasa}</td>
                                                        <td style={{ padding: '12px 0', color: '#6b7280', textTransform: 'capitalize' }}>{voto.rolVotante}</td>
                                                        <td style={{ padding: '12px 0' }}>
                                                            {encuesta.reglas.esAnonima ? (
                                                                <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Oculto (Anónimo)</span>
                                                            ) : (
                                                                <span style={{ color: '#8b5cf6', fontWeight: 'bold' }}>{getOpcionTexto(voto.opcionId)}</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <KondoBottomNav activeRoute="" />
            </main>
        </div>
    );
}

export default ResultadosEncuestasScreen;
